import store from '@/store';
import ApiService from '@/services/ApiService';
import ApiEndpoints from '@/config/ApiEndpoints';
import CountryService from '@/services/logistics/CountryService';

export default class ValidateDelivery {
    /**
     * ApiService instance.
     *
     * @var {ApiService}
     */
    apiService;

    /**
     * ValidateDelivery constructor.
     *
     * @param {ApiService|null}          apiService
     *
     * @returns {void}
     */
    constructor(apiService = null) {
        this.apiService = apiService || new ApiService(process.env.VUE_APP_API_URL);
    }

    /**
     * Handle validating the delivery step of the registration.
     *
     * @returns {Promise}
     */
    handle() {
        return this.apiService
            .post(ApiEndpoints['users.validate.registration.delivery.store'], this.getPayload());
    }

    /**
     * Fetch and prepare the payload to send to the API.
     *
     * @returns {Object}
     */
    getPayload() {
        let deliveryAddress = store.getters['register/getDeliveryAddress'];
        let deliveryAddressCountry = CountryService.findCountryByIso(deliveryAddress.country);
        deliveryAddressCountry = deliveryAddressCountry ? deliveryAddressCountry.name : null;

        return {
            delivery_address_line_1: deliveryAddress.addressLine1,
            delivery_address_line_2: deliveryAddress.addressLine2,
            delivery_address_city: deliveryAddress.city,
            delivery_address_postcode: deliveryAddress.postcode,
            delivery_address_country: deliveryAddressCountry,
            delivery_address_property_type: store.getters['register/getPropertyType'],
            delivery_instructions: store.getters['register/getDeliveryComment'],
            telephone: store.getters['register/getTelephone'],
        };
    }
}
